import clone from 'lodash/clone';
import templateUrl from '../in-the-news-template.html';

export const inTheNewsMainComponent = {
	templateUrl,

	//binding title, details and onSubmit function
	bindings: {
		pageTitle: '@',
		details: '<',
		onSubmit: '&',
		onSavePublish: '&',
		onRepublish: '&',
		disableButtons: '<',
		showRepublishButton: '<',
		showSavePublishTypeButton: '<',
		parentSlug: '@'
	},

	//controller for InTheNewsMainComponent
	controller: class InTheNewsMainComponent {
		constructor($state, $parse, ModalService, CompareObjectService, DateService) {
			'ngInject';

			this.$state = $state;
			this.$parse = $parse;
			this.modalService = ModalService;
			this.compareObjectService = CompareObjectService;
			this.dateService = DateService;
		}

		$onInit() {
			this.dateError = false;
			this.editorFieldError = false;
			this.details = this.details || {
				title: "",
				description: "",
				images: [],
				videos:[],
				newsDate: ""
			};
			
			this.newsDateDetails = {
				title: "News Date*",
				isRequired: true,
				selectedDate: this.details.newsDate
			};
			this.saveData = angular.copy(this.details);
		}

		setEditorDetails(editorDetails) {
			this.details = clone(editorDetails);
			this._checkEditorFieldError();
		}

		//on cancel function
		onCancel() {
			const _details = angular.copy(this.details);
			const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.saveData, _details, true);
			if (isUpdated) {
				this.modalService.open({
					details: {
						bodyMessage: 'Changes done will be reverted. Continue?'
					},

					buttons: [
						{
							name: 'No'
						},
						{
							name: 'Yes',
							isPrimary: true,
							action: onSubmit.bind(this)
						}
					]
				});
			} else {
				this._redirectToParentState(this.parentSlug);
			}

			function onSubmit() {
				this._redirectToParentState(this.parentSlug);
			}
		}

		_onSubmit() {
			this._setNewsDate();
			this._checkEditorFieldError();

			if(!this.editorFieldError) {
					if (this.showRepublishButton) {
						this.details.isActive = true;
						this.onRepublish({
							details: this.details
						});
					} else {
						this.details.isActive = false;
						this.onSubmit({
							details: this.details
						});
					}
			}
		}

		_redirectToParentState(slug) {
            this.$state.go('app.dashboard.DynamicMenus', {
                url: slug
            });
        }

		_onSavePublish() {
			this._setNewsDate();
			this._checkEditorFieldError();

			if(!this.dateError && !this.editorFieldError) {
				this.details.isActive = true;
				this.onSubmit({
					details: this.details
				});
			}
		}

		_onRepublish() {
			this._setNewsDate();
			this._checkEditorFieldError();

			if(!this.dateError && !this.editorFieldError) {
				this.details.isActive = true;
				this.onSubmit({
					details: this.details
				});
			}
		}

		_checkEditorFieldError() {
			this.editorFieldError = this.details.description.trim().length > 0 ? false : true;
		}

		_setNewsDate(){
			if(this.newsDateDetails.selectedDate) {
				this.dateError = false;
				const date = this.dateService.getDate(this.newsDateDetails.selectedDate);
				this.details.newsDate = date;
			} else {
				this.dateError = true;
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/about-us/in-the-news/in-the-news-main/in-the-news-main.component.js